

import { createContext } from 'react'

const PaymentContext = createContext({
  createPaymentRequest: () => {},
  createPaymentResponse: () => {},
  createApplePayMerchantSession: () => {},
  deletePaymentProviderToken: () => {},
  fetchPaymentProviderTokens: () => {}
})

export default PaymentContext
